import { Box } from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import ModalTemplate from '@components/modalTemplate';
import { usePopUpNotification } from '@store/popupNotification';
import { useUserInfo } from '@store/userInfo';
import { PageContext } from '@pages/UploadSellout';
import { isActiveButtonHandler } from '@pages/UploadSellout/helpers/utils';
import { usePopUpAssetStore, usePopUpStore } from '@pages/UploadSellout/components/uploadPopUp/state';
import { onCheckIsBlockUpload } from '@pages/UploadSellout/helpers/utils';
import { onUploadFile, fetchAssets } from '../../helpers/crud';
import './styles.scss';
import { useUploadStore } from '@pages/UploadSellout/helpers/mainState';
import { useNavigate } from 'react-router-dom';
import HeaderSection from './components/modalSection/header';
import BodySection from './components/modalSection/body';
import FooterSection from './components/modalSection/footer';
import { useDataKonversi } from '@pages/UploadSellout/hooks/state/useDataKonversi';

const link =
    'https://paracorpgroup-my.sharepoint.com/:w:/p/muhammad_adobson/EZ0JQ3_gVapMpZNxFzBGjkoB14LK0UA36jn9oVLslqYT5Q?e=qoCQtF';

const UploadPopUp = () => {
    const popUpStore = usePopUpStore();
    const fileState = useUploadStore();
    const { setData } = useDataKonversi();
    const selectedFile = fileState.file;
    const { onFetchUploadData } = useContext(PageContext);
    const { userInfo } = useUserInfo();
    const modalWidth = '520px';
    const navigate = useNavigate();

    const { onChangePopUpNotification } = usePopUpNotification();

    const {
        isOpen,
        selectedTimeUploadType,
        onChangePopUpStore,
        selectedTimeUploadValue,
        onResetPopUpStore,
        isUploading: isLoading,
    } = popUpStore;

    const { onChangePopupAssetStore, blockedUpload, progress, controller } = usePopUpAssetStore();

    const isBlockUpload = onCheckIsBlockUpload({ selectedTimeUploadValue, selectedTimeUploadType, blockedUpload });
    const isActiveButton = isActiveButtonHandler({ store: popUpStore, isBlockUpload });

    const handleClose = () => {
        onChangePopUpStore({
            isOpen: false,
        });
    };

    const handleChangeFile = () => {
        fileState.onResetUploadtore();
        onResetPopUpStore();
    };

    const handleCancel = () => {
        if (controller) {
            controller.abort();
        }
        onResetPopUpStore();
        fileState.onResetUploadtore();
    };

    const handleSubmit = async () => {
        const isValid = popUpStore.validateFormPopUpStore();
        if (!isValid) return;

        onChangePopUpStore({ isUploading: true });
        onChangePopupAssetStore({ progress: 0 });

        let currentProgress = 0;

        const uploadProgress = setInterval(() => {
            currentProgress = Math.min(currentProgress + 5, 95);
            onChangePopupAssetStore({ progress: currentProgress });

            if (currentProgress >= 95) {
                clearInterval(uploadProgress);
            }
        }, 100);

        try {
            await onUploadFile({
                popUpStore: { ...popUpStore, selectedFile },
                onChangePopUpStore,
                onResetPopUpStore,
                onClose: handleClose,
                isCanUpload: isActiveButton,
                onChangePopUpNotification,
                onRefetchUploadData: onFetchUploadData,
                userInfo,
                onResetFile: fileState.onResetUploadtore,
                onNavigate: (path) => navigate(path),
                onChangePopupAssetStore,
                onSmartUploadSuccess: setData,
            });

            clearInterval(uploadProgress);
            onChangePopUpStore({ isUploading: false });
        } catch (error) {
            clearInterval(uploadProgress);
            onChangePopUpStore({ isUploading: false });
            onChangePopupAssetStore({ progress: 0 });

            throw error;
        }
    };

    useEffect(() => {
        fetchAssets({ onChangePopupAssetStore });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (selectedFile?.type === 'application/pdf') {
            onChangePopUpStore({
                selectedFormatUploadType: 'Smart Upload',
            });
        }
    }, [selectedFile]);

    return (
        <ModalTemplate
            width={modalWidth}
            isOpen={isOpen}
            isCentered={false}
            onClose={handleClose}
            isClosebyOverlayClick={false}
        >
            <Box className="modal-upload-and-data-checking__container">
                <HeaderSection
                    isLoading={isLoading}
                    handleClose={handleClose}
                    selectedFile={selectedFile}
                    handleChangeFile={handleChangeFile}
                    link={link}
                />

                <BodySection />

                <FooterSection
                    handleSubmit={handleSubmit}
                    handleCancel={handleCancel}
                    progress={progress}
                    link={link}
                />
            </Box>
        </ModalTemplate>
    );
};

export default UploadPopUp;
